// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-manager {
  /* margin: 20px 0; */
  text-align: center;
  overflow: hidden;
}

@media (max-width: 430px) {
  .ad-manager {
    width: 100%;
    height: 233px !important;
    min-width: 0;
  }

  .ad-manager .slick-slider {
    width: 100%;
  }

  .ad-manager .slick-list {
    width: 100%;
  }
}

.grid-sixth-tile .ad-manager,
.grid-sixth-tile .ant-carousel,
.grid-sixth-tile .slick-slider,
.grid-sixth-tile .slick-list,
.grid-sixth-tile .slick-track,
.grid-sixth-tile .slick-slide,
.grid-sixth-tile .slick-slide > div,
.grid-sixth-tile .slick-slide > div > div,
.grid-sixth-tile .ant-image {
  height: 100% !important;
}
.grid-sixth-tile .ant-image-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: fill !important;
}
.grid-sixth-tile .slick-slide > div {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/Ads/adManager/adManager.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC","sourcesContent":[".ad-manager {\n  /* margin: 20px 0; */\n  text-align: center;\n  overflow: hidden;\n}\n\n@media (max-width: 430px) {\n  .ad-manager {\n    width: 100%;\n    height: 233px !important;\n    min-width: 0;\n  }\n\n  .ad-manager .slick-slider {\n    width: 100%;\n  }\n\n  .ad-manager .slick-list {\n    width: 100%;\n  }\n}\n\n.grid-sixth-tile .ad-manager,\n.grid-sixth-tile .ant-carousel,\n.grid-sixth-tile .slick-slider,\n.grid-sixth-tile .slick-list,\n.grid-sixth-tile .slick-track,\n.grid-sixth-tile .slick-slide,\n.grid-sixth-tile .slick-slide > div,\n.grid-sixth-tile .slick-slide > div > div,\n.grid-sixth-tile .ant-image {\n  height: 100% !important;\n}\n.grid-sixth-tile .ant-image-img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: fill !important;\n}\n.grid-sixth-tile .slick-slide > div {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
